module.exports = __webpack_public_path__ + "static/media/logo_sku.7ab75438.png";